import { AcMenuLanguages } from "../types/acMenu";

export function parseAcMenuLanguages(
  languages: string | AcMenuLanguages | null | undefined
): AcMenuLanguages {
  if (!languages) {
    return { en: "", zhCN: "", jp: "" };
  }
  if (typeof languages === "object") {
    return {
      en: languages.en || "",
      zhCN: languages.zhCN || "",
      jp: languages.jp || "",
    };
  }
  try {
    const parsed = JSON.parse(languages || "{}") as AcMenuLanguages;
    return {
      en: parsed?.en || "",
      zhCN: parsed?.zhCN || "",
      jp: parsed?.jp || "",
    };
  } catch {
    return { en: "", zhCN: "", jp: "" };
  }
}
